import cn from 'classnames';
import React, { ReactNode } from 'react';

import s from './styles.module.css';

interface IProps {
  children: ReactNode;
  intent?: 'default' | 'success' | 'warning' | 'danger';
}

const Tag = ({ children, intent }: IProps) => (
  <div className={cn(s.tag, intent && s[intent] ? s[intent] : null)}>{children}</div>
);

export { Tag };
